"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLoadExtensions = void 0;
const react_1 = require("react");
const react_query_1 = require("@tanstack/react-query");
const http_client_1 = require("../http-client");
const module_federation_1 = require("@invent/module-federation");
const notifications_1 = require("../notifications");
const traceId = 'c977b993-8e17-496f-a6d7-40fa0fecca52';
function createCompanionScriptTag(meta, onLoad, onError) {
    const devFederation = DEV_FEDERATION;
    const element = document.createElement('script');
    if (devFederation.includes(String(meta.id)) || devFederation.includes(meta.name)) {
        element.src = `http://localhost:5${meta.id}/remoteEntry.js`;
    }
    else {
        element.src = meta.companion;
    }
    element.id = meta.name;
    element.type = 'text/javascript';
    element.async = true;
    element.onload = () => __awaiter(this, void 0, void 0, function* () {
        const instance = (0, module_federation_1.loadComponentLegacy)(meta.scope, meta.module);
        const module = yield instance();
        const CompanionClass = module.default;
        onLoad(meta.name, new CompanionClass(meta));
        console.log(`Companion Script Loaded: ${meta.name}`);
    });
    element.onerror = () => {
        onError(meta.name);
        (0, notifications_1.catchAndNotify)({
            message: `Companion Script Error: ${meta.name}`,
            traceId
        });
    };
    document.head.appendChild(element);
}
const useLoadExtensions = (isTokenValid) => {
    const [extensions, setExtensions] = (0, react_1.useState)(new Map());
    const [errors, setErrors] = (0, react_1.useState)(new Set());
    const handleCompanionScriptLoad = (0, react_1.useCallback)((name, value) => {
        setExtensions((prev) => {
            prev.set(name, value);
            return new Map(prev);
        });
        setErrors((prev) => {
            prev.delete(name);
            return new Set(prev);
        });
    }, []);
    const handleCompanionScriptError = (0, react_1.useCallback)((name) => {
        setErrors((prev) => {
            prev.add(name);
            return new Set(prev);
        });
    }, []);
    const { data: extList, isFetching } = (0, react_query_1.useQuery)({
        queryKey: ['wlabel', 'extensions', 'list'],
        queryFn({ signal }) {
            return (0, http_client_1.httpClient)(`${window.CUSTOMIZATION_BE}/extensions/list`, {
                signal,
                traceId
            });
        },
        enabled: isTokenValid === true,
        retry: false,
        refetchOnWindowFocus: false,
        onSuccess(extensions) {
            extensions.forEach((companion) => {
                createCompanionScriptTag(companion, handleCompanionScriptLoad, handleCompanionScriptError);
            });
        },
        onError() {
            (0, notifications_1.catchAndNotify)({
                message: 'Extensions Request Error',
                traceId
            });
        }
    });
    const getExtensionsList = (0, react_1.useCallback)(() => {
        return Array.from(extensions.entries());
    }, [extensions]);
    const getExtension = (0, react_1.useCallback)((name) => {
        return extensions.get(name);
    }, [extensions]);
    return {
        areAllExtensionsLoaded: !isFetching && (extList === null || extList === void 0 ? void 0 : extList.length) === extensions.size + errors.size,
        getExtension,
        getExtensionsList
    };
};
exports.useLoadExtensions = useLoadExtensions;
